export const emptyNlpEvent = {
    _id: '',
    user: '',
    task_id: '',
    group: '',
    subgroup: '',
    option: '',
    start: 0
}

export interface NlpEvent {
    _id: string;
    user: string;
    task_id: string;
    group: string;
    subgroup: string;
    option: string;
    start: number;
}
